import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { PolicyTokenHeaderName } from '@benefitsui/app/lib/http/http.types';
import { PolicyTokensAccessor } from '@benefitsui/app/lib/policy/policy-token/policy-token-accessor.service';

@Injectable()
export class HttpPolicyTokenInterceptor<T> implements HttpInterceptor {
  constructor(private tokensAccessor: PolicyTokensAccessor) {}
  intercept(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const token = this.tokensAccessor.get().value.join(',');
    let request = req;
    if (token) {
      request = req.clone({ setHeaders: { [PolicyTokenHeaderName]: token } });
    }
    return next.handle(request);
  }
}

export const httpPolicyTokenInterceptorProviders: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpPolicyTokenInterceptor, multi: true }
];
